module.exports = __webpack_public_path__ + "static/img/资产png.824dba7d.png";